import { render, staticRenderFns } from "./matchSub.vue?vue&type=template&id=473f53d0&scoped=true&"
import script from "./matchSub.vue?vue&type=script&lang=js&"
export * from "./matchSub.vue?vue&type=script&lang=js&"
import style0 from "./matchSub.vue?vue&type=style&index=0&id=473f53d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f53d0",
  null
  
)

export default component.exports